// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fF","advertDetailContactGroup__header":"c-m_fG","advertDetailContactGroup__value":"c-m_fH"};